// extracted by mini-css-extract-plugin
export var alignCenter = "_9w-d";
export var bannerShown = "_9w-6";
export var buttonContent = "_9w-0";
export var cardList = "_9w-1";
export var centerContent = "_9w-2";
export var chevron = "_9w-3";
export var closePanelButton = "_9w-k";
export var conversationContextContainer = "_9w-l";
export var conversationDetailContainer = "_9w-4";
export var detailWrapper = "_9w-7";
export var dropdownButton = "_9w-e";
export var dropdownTitle = "_9w-9";
export var fullHeight = "_9w-5";
export var hidden = "_9w-a";
export var icon = "_9w-b";
export var mergeSuggestionWrapper = "_9w-m";
export var panel = "_9w-i";
export var portalButtonsWrapper = "_9w-c";
export var right = "_9w-j";
export var tableSummaryContainer = "_9w-8";
export var tableSummaryHeader = "_9w-g";
export var threeDotsButton = "_9w-f";
export var wide = "_9w-h";